import { BiData } from '@wix/da-bi/pkg/events';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import camelCase from 'lodash/camelCase';
import { DeviationResourceType } from '../types/deviation';
import { GallectionResourceType } from '../types/gallection';
import { ResourceType } from '../types/resource';
import { getBasicTierSubscriptionInfo } from '../utils/hooks/useSubscriptionTier';
/*
    The helpers in this file exist to contain as much of the special casing for
    various blocks as possible. If you find yourself writing something checking
    for contentType, see if it can be extracted here instead of hiding in more
    general components.
 */ export function getMoreByLinkType(contentType) {
    switch(contentType){
        case 'gallery':
            return 'gallery';
        default:
    }
}
export function getBlockBI(contentType) {
    const biData = {
        sectionname: camelCase(contentType)
    };
    switch(contentType){
        case 'gallery':
            biData.section_typeid = GallectionResourceType.GALLERY;
            break;
        case 'collections':
            {
                biData.section_typeid = GallectionResourceType.COLLECTION;
                break;
            }
        default:
    }
    return biData;
}
export function getSeeAllBI(contentType, deviation) {
    const biData = BiData({
        evid: 106
    });
    switch(contentType){
        case 'in_tier':
        case 'more_tiers':
        case 'selected_tier':
            var _tier;
            const { isTier, tier } = getBasicTierSubscriptionInfo(deviation);
            var _tier_deviationId;
            return BiData({
                evid: 547,
                itemid: (_tier_deviationId = (_tier = tier) === null || _tier === void 0 ? void 0 : _tier.deviationId) !== null && _tier_deviationId !== void 0 ? _tier_deviationId : 0,
                typeid: DeviationResourceType.TIER,
                referral_info: isTier ? ReferralType.COMPARE_TIER_UNIQUE : ReferralType.COMPARE_CONTENT_PAGE
            });
        default:
    }
    return biData;
}
export function getTierListCardBI(contentType, deviation) {
    const biData = {
        evid: BiEventType.VIEW_TIER_UNIQUE,
        referral_info: ReferralType.SIDE_BAR_TIER_UNIQUE,
        itemid: deviation.deviationId,
        typeid: ResourceType.TIER
    };
    switch(contentType){
        case 'in_tiers':
            biData.referral_info = ReferralType.SIDE_BAR_CONTENT_PAGE;
            break;
        default:
    }
    return biData;
}
